import { FETCH_MANAGE_GROUPS, FETCH_MANAGE_GROUPS_SUCCESS, FETCH_MANAGE_GROUPS_FAIL } from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  data: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_MANAGE_GROUPS:
      return { ...state, loading: true }
    case FETCH_MANAGE_GROUPS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case FETCH_MANAGE_GROUPS_FAIL:
      return { ...state, loading: false }
    default:
      return (state)
  }
}
